// tslint:disable
export enum EnrollmentApiPaymentType {
    // No Error
    'debitcard' = 'debitcard',
    'check' = 'check',
    'virtualdebitcard' = 'virtualdebitcard',
    'thirdpartyadjudication' = 'thirdpartyadjudication',
    'sitecheckforpatient' = 'sitecheckforpatient',
    'sitecheckforsite' = 'sitecheckforsite',
    'efttosite' = 'efttosite',
    'copaycard' = 'copaycard',
}
